import { Appointment } from "./appointment.definition";
import { Doctor } from "./doctor";
import { Manager } from "./manager";
import { Patient } from "./patient";
import { UserInfo } from "./user.definition";
export type Session = {
  user: UserInfo;
  metadata: {
    doctor?: Partial<Doctor>;
    patient?: Patient;
    manager?: Partial<Manager>;
  };
  appointments: Appointment[];
  loading: boolean;
  /** PIN lock (MED-1620): missing on an API without the PIN feature. */
  hasPin?: boolean;
  locked?: boolean;
  /** Minutes without activity before the screen locks (MED-1642). */
  pinLockMinutes?: number;
};

export type ValidateSessionSuccessPayload = {
  expiresAt: string;
  sessionId: string;
  sessionStatus: SessionStatus;
  settings?: { features: Record<string, boolean> };
  hasPin?: boolean;
  locked?: boolean;
};

export enum SessionStatus {
  INVALID_SESSION = "INVALID_SESSION",
  VALID_SESSION = "VALID_SESSION",
}
